// Lets other processes run to avoid blocking the server or browser for too long

export default function () {
  // return new Promise(() => {});
  return Promise.resolve(123);
};
